import { Card, Col, Container, Row } from 'reactstrap'
import { Gallery, MasonryGalleryCap } from '../../../../utils/Constant'
import MasonryGalleryBody from './MasonryGalleryBody'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs/Breadcrumbs'
import CommonCardHeader from '../../../../CommonElements/CommonCardHeader/CommonCardHeader'

const MasonryGalleryContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={MasonryGalleryCap} parent={Gallery} />
      <Container fluid>
        <Row>
          <Col sm="12" className="box-col-12">
            <Card>
              <CommonCardHeader title={MasonryGalleryCap} />
              <MasonryGalleryBody />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default MasonryGalleryContainer